const eloAdminUrls = {
  eloAdminProd: 'http://elx-admin-mr.atlas-apps.mit.edu',
  eloAdminDevTest: 'https://elo-admin-v2.atlas-apps{stage}.mit.edu'
}

export default eloAdminUrls
